import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";

import ProductSection from "./Products";
import CategorySection from "./Category";
import WhyChooseUs from "../Components/WhyChooseUs";

export default function HeroSection() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await axios.get("https://accessoriesgirly.onrender.com/api/banners");
        setBanners(res.data);
      } catch (err) {
        console.error("Error fetching banners:", err);
      }
    };
    fetchBanners();
  }, []);

  // 🔹 Slider settings
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div>
      {/* Banner Carousel */}
      <section className="relative">
        <Slider {...settings}>
          {banners.map((banner) => (
            <div key={banner._id} className="relative w-full h-[50vh] md:h-[70vh]">
              <img
                src={banner.image}
                alt={banner.name}
                className="w-full h-full object-cover"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                <div className="text-center px-4">
                  <h1 className="text-3xl md:text-5xl font-bold text-white drop-shadow-lg">
                    {banner.name || (
                      <>
                        Welcome to <span className="text-pink-600">Accessories Girly</span>
                      </>
                    )}
                  </h1>
                  <p className="mt-3 text-base md:text-lg text-gray-200 max-w-2xl mx-auto">
                    {banner.description || "Discover the best deals on fashion and more."}
                  </p>

                  {/* Buttons */}
                  <div className="mt-5 flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                      to="/products"
                      className="px-5 py-2 bg-pink-600 text-white font-semibold rounded-full shadow-lg hover:bg-pink-700 transition"
                    >
                      Shop Now
                    </Link>
                    <Link
                      to="/categories"
                      className="px-5 py-2 bg-white text-gray-900 font-semibold rounded-full shadow-lg hover:bg-gray-200 transition"
                    >
                      Explore Categories
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>

      {/* Other sections */}
      <CategorySection />
      <ProductSection />
      <WhyChooseUs />
    </div>
  );
}
